var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "DialogMovePlanTasks", attrs: { dir: "rtl" } },
    [
      _c(
        "div",
        { staticClass: "modal-card", staticStyle: { width: "460px" } },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title" }, [
              _vm._v("העברת משימות לתאריך אחר"),
            ]),
            _c("button", {
              staticClass: "delete",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            }),
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _c(
                "p",
                { staticClass: "DialogMovePlanTasks__Count" },
                [
                  _vm.tasks.length === 1
                    ? [
                        _vm._v(" העברת המשימה "),
                        _c("b", [_vm._v(_vm._s(_vm.singleName))]),
                        _vm._v(". "),
                      ]
                    : [
                        _vm._v(" נבחרו "),
                        _c("b", [_vm._v(_vm._s(_vm.tasks.length))]),
                        _vm._v(" משימות להעברה. "),
                      ],
                ],
                2
              ),
              _vm.currentDatesLabel
                ? _c("p", { staticClass: "DialogMovePlanTasks__From" }, [
                    _vm._v(
                      " תאריך נוכחי: " + _vm._s(_vm.currentDatesLabel) + " "
                    ),
                  ])
                : _vm._e(),
              _c(
                "b-field",
                { attrs: { label: "תאריך יעד" } },
                [
                  _c("b-datepicker", {
                    attrs: {
                      icon: "calendar-today",
                      placeholder: "בחר תאריך",
                      "trap-focus": "",
                      editable: "",
                    },
                    model: {
                      value: _vm.date,
                      callback: function ($$v) {
                        _vm.date = $$v
                      },
                      expression: "date",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "note" }, [
                _vm._v(
                  " שאר פרטי השיבוץ (חלון זמן, שעות, משך וסדר בתוך היום) יישארו ללא שינוי. "
                ),
              ]),
            ],
            1
          ),
          _c(
            "footer",
            { staticClass: "modal-card-foot" },
            [
              _c("b-button", {
                attrs: {
                  loading: _vm.isLoading,
                  disabled: _vm.date == null,
                  type: "is-primary",
                  label: "העבר",
                },
                on: { click: _vm.save },
              }),
              _c("b-button", {
                attrs: { disabled: _vm.isLoading, label: "ביטול" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }